import React, { createContext, useContext, useState } from 'react';

// 1. Define the initial state for the score.
const initialScore = 0; // Or null, if you prefer to indicate "not yet calculated"

// 2. Create the new context.
const SemanticScoreContext = createContext({
  semanticScore: initialScore,
  updateSemanticScore: () => {}, // Function to set a new score
});

// 3. Create the Provider component.
// This component will wrap your other components and provide the score data.
export const SemanticScoreProvider = ({ children }) => {
  const [semanticScore, setSemanticScore] = useState(initialScore);

  // This function will be called from the child component to update the score.
  const updateSemanticScore = (newScore) => {
    setSemanticScore(newScore || 0); // Ensure we always have a number
  };

  const value = {
    semanticScore,
    updateSemanticScore,
  };

  return (
    <SemanticScoreContext.Provider value={value}>
      {children}
    </SemanticScoreContext.Provider>
  );
};

// 4. Create the custom hook for easy consumption.
// This is what your parent component will use to get the score.
export const useSemanticScore = () => {
  const context = useContext(SemanticScoreContext);
  if (context === undefined) {
    throw new Error(
      'useSemanticScore must be used within a SemanticScoreProvider'
    );
  }
  return context;
};
